import React from 'react';
import ReactDOM from 'react-dom/client';
import './tokens.css';
import './index.css';
import App from './App';
import { TooltipGlobal } from './Tooltip';

const root = ReactDOM.createRoot(document.getElementById('root'));
const mostrarApp = () => root.render(
  <React.StrictMode>
    <App />
    <TooltipGlobal />
  </React.StrictMode>
);

// Vistas previas de Vercel: datos de ejemplo en lugar del servidor real (ver demo.js).
// demo.js va en un archivo aparte que producción nunca descarga; la app se muestra
// hasta que la demo está lista, para que ninguna petición llegue al servidor real.
if (process.env.REACT_APP_DEMO === 'true') {
  import('./demo').then(({ instalarDemo }) => {
    instalarDemo();
    mostrarApp();
  });
} else {
  mostrarApp();
}
